import { createGlobalStyle } from "styled-components";
import { darken } from "polished";

export const base_colors = {
    color_white: "#ffffff",
    color_black: "#1f1a33",
    color_beige: "#FEF3D5",
    color_violet: "#614494",
    color_blue: "#b6d2de",
};

export const colors = {
    //?\\ global
    white: "var(--white)",
    black_light: "var(--black-light)",
    black: "var(--black)",
    bg_body: "var(--white)",

    //?\\ typo
    typo_link_hover: "var(--typo-link-hover)",
    typo_link: "var(--typo-link)",
    typo_positive: "var(--typo-positive)",
    typo_negative: "var(--typo-negative)",
    typo_inverse: "var(--typo-inverse)",
    typo_placeholder: "var(--typo-placeholder)",
    typo_secondary: "var(--typo-secondary)",
    typo_primary: "var(--typo-primary)",
    typo_interactive: "var(--typo-interactive)",

    beige_base: "var(--beige-base)",
    beige_hover: "var(--beige-hover)",
    beige_active: "var(--beige-active)",

    violet_base: "var(--violet-base)",
    violet_hover: "var(--violet-hover)",
    violet_active: "var(--violet-active)",

    blue_base: "var(--blue-base)",
    blue_hover: "var(--blue-hover)",
    blue_active: "var(--blue-active)",
};

export const VarsThemeStyle = createGlobalStyle`
    :root {
        //?\\ global
        --white: #FFFFFF;
        --black-light: #292929;
        --black: #111111;

        //?\\ typo
        --typo-link-hover: #1053AB;
        --typo-link: #0078D2;
        --typo-positive: #72C570;
        --typo-negative: #EB5757;
        --typo-inverse: #F4F4F4;
        --typo-placeholder: #B9B9B9;
        --typo-secondary: #8A8A8E;
        --typo-primary: ${base_colors?.color_black};
        --typo-interactive: #EF5048;

        --beige-base: ${base_colors?.color_beige};
        --beige-hover: ${darken(0.1, base_colors?.color_beige)};
        --beige-active: ${base_colors?.color__active};

        --violet-base: ${base_colors?.color_violet};
        --violet-hover: ${base_colors?.color_violet};
        --violet-active: ${base_colors?.color_violet};
        
        --blue-base: ${base_colors?.color_blue};
        --blue-hover: ${base_colors?.color_blue};
        --blue-active: ${base_colors?.color_blue};

    }
`;
